import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=d2544e3c&scoped=true&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=d2544e3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2544e3c",
  null
  
)

export default component.exports